import { render, staticRenderFns } from "./SortSmallClass.vue?vue&type=template&id=afc51974&scoped=true"
import script from "./SortSmallClass.vue?vue&type=script&lang=js"
export * from "./SortSmallClass.vue?vue&type=script&lang=js"
import style0 from "./SortSmallClass.vue?vue&type=style&index=0&id=afc51974&prod&scoped=true&lang=stylus"
import style1 from "./SortSmallClass.vue?vue&type=style&index=1&id=afc51974&prod&lang=stylus"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "afc51974",
  null
  
)

export default component.exports